var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5306 7.28063L9.53063 19.2806C9.46097 19.3504 9.37825 19.4057 9.28721 19.4434C9.19616 19.4812 9.09856 19.5006 9 19.5006C8.90144 19.5006 8.80384 19.4812 8.71279 19.4434C8.62175 19.4057 8.53903 19.3504 8.46937 19.2806L3.21938 14.0306C3.07864 13.8899 2.99958 13.699 2.99958 13.5C2.99958 13.301 3.07864 13.1101 3.21938 12.9694C3.36011 12.8286 3.55098 12.7496 3.75 12.7496C3.94902 12.7496 4.13989 12.8286 4.28062 12.9694L9 17.6897L20.4694 6.21937C20.6101 6.07864 20.801 5.99958 21 5.99958C21.199 5.99958 21.3899 6.07864 21.5306 6.21937C21.6714 6.36011 21.7504 6.55098 21.7504 6.75C21.7504 6.94902 21.6714 7.1399 21.5306 7.28063Z",
    fill: "#149041"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckin);
export default __webpack_public_path__ + "static/media/checkin.5d610cc7733c74c607b6c2f63be24103.svg";
export { ForwardRef as ReactComponent };